/* Cart Shadow: native theme events + official full Ajax Cart API. No checkout mutation. */
(() => {
  if (window.AmbientaCartShadow) return;
  const root = window.Shopify?.routes?.root || "/";
  const storageKey = "ambienta-cart-shadow-session-v2";
  let busy = false,
    pending = false,
    timer,
    session,
    lastFingerprint = "",
    lastSent = 0,
    retry;
  const permitted = () =>
    window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  function sessionId() {
    try {
      session ||= localStorage.getItem(storageKey);
      if (!session) {
        session = crypto.randomUUID();
        localStorage.setItem(storageKey, session);
      }
      return session;
    } catch {
      return null;
    }
  }
  async function capture() {
    if (!permitted() || document.hidden) return;
    if (busy) {
      pending = true;
      return;
    }
    const id = sessionId();
    if (!id) return;
    busy = true;
    try {
      const response = await fetch(root + "cart.js", {
        credentials: "same-origin",
        cache: "no-store",
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (!cart.token || !Array.isArray(cart.items)) return;
      const fingerprint = JSON.stringify(cart);
      if (fingerprint === lastFingerprint && Date.now() - lastSent < 60000)
        return;
      if (!retry || retry.fingerprint !== fingerprint)
        retry = { fingerprint, event_id: crypto.randomUUID() };
      const result = await fetch("/apps/ambienta-cart/continuous", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          observation_context: "production",
          session_id: id,
          event_id: retry.event_id,
          cart,
        }),
      });
      if (!result.ok) return;
      const status = await result.json();
      if (!status.accepted) return;
      lastFingerprint = fingerprint;
      lastSent = Date.now();
      retry = null;
      // Never send or infer an email/customer ID. Shopify proxy supplies signed identity.
      // A server conflict stays blocked; don't clear the actual cart or change visible UX.
    } catch {
      /* Persistence unknown: no eligibility, no cart/checkout changes. */
    } finally {
      busy = false;
      if (pending) {
        pending = false;
        schedule();
      }
    }
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(capture, 400);
  }
  [
    "afterCartChanged",
    "afterUpdateQuantity",
    "ambienta:cart-changed",
    "visitorConsentCollected",
  ].forEach((name) => document.addEventListener(name, schedule));
  window.addEventListener("pageshow", schedule);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) schedule();
  });
  // Covers changes from other widgets without intercepting their network calls.
  const poll = setInterval(() => {
    if (!document.hidden && permitted()) schedule();
  }, 30000);
  window.AmbientaCartShadow = {
    capture,
    afterSuccessfulCartChange: schedule,
    stop() {
      clearInterval(poll);
      clearTimeout(timer);
    },
  };
  window.Shopify?.loadFeatures?.(
    [{ name: "consent-tracking-api", version: "0.1" }],
    schedule,
  );
  schedule();
})();
